import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in Italian. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsIt: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "Pagamenti",
  "payments.tab.approvals": "Richieste di approvazione",
  "payments.pick": "Scegli un pagamento dall'elenco.",
  "payments.loading": "Caricamento del pagamento…",
  "payments.loadFailed": "Impossibile caricare questo pagamento.",
  "payments.notFound": "Questo pagamento non si trova. Ricarica l'elenco.",
  "payments.refreshFailed": "Non è stato possibile aggiornare il pagamento: è mostrato com'era.",

  "payments.filter.provider": "Metodo di pagamento",
  "payments.filter.status": "Stato",
  "payments.filter.all": "Tutti",
  "payments.filter.from": "Dal",
  "payments.filter.to": "Al",
  "payments.filter.duplicates": "Probabili doppioni",
  "payments.filter.clearPro": "Tutti i pro",
  "payments.list.loading": "Caricamento dei pagamenti…",
  "payments.list.loadFailed": "Impossibile caricare i pagamenti.",
  "payments.list.empty": "Nessun pagamento per questi filtri.",
  "payments.list.aria": "Pagamenti delle commissioni",
  "payments.list.end": "Fine dell'elenco",
  "payments.pill.duplicate": "Probabile doppione",

  "payments.status.pending": "Da pagare",
  "payments.status.paid": "Pagato",
  "payments.status.failed": "Non riuscito",
  "payments.status.refunded": "Rimborsato",
  "payments.status.waived": "Commissione annullata",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "Carta (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "Commissione per contatto",
  "payments.feeType.monthly": "Abbonamento mensile",
  "payments.feeType.yearly": "Abbonamento annuale",
  "payments.kind.refund": "Rimborso",
  "payments.kind.credit": "Credito",
  "payments.kind.waive": "Annullamento della commissione",
  "payments.kind.mark_paid": "Segnato come pagato",

  "payments.detail.versionTitle": "La versione del pagamento mostrata: ogni correzione la invia.",
  "payments.detail.duplicate": "Probabile doppione",
  "payments.detail.duplicateBody":
    "Un altro pagamento dello stesso pro, dello stesso importo, pochi minuti prima o dopo. Controlla prima di rimborsare:",
  "payments.detail.pro": "Professionista",
  "payments.detail.proPayments": "I suoi pagamenti →",
  "payments.detail.transaction": "Riferimento presso il fornitore",
  "payments.detail.job": "Richiesta",
  "payments.detail.refunded": "Già rimborsato",
  "payments.detail.refundable": "Ancora rimborsabile",
  "payments.detail.credit": "Credito del pro",
  "payments.detail.adjustments": "Correzioni",
  "payments.detail.noAdjustments": "Nessuna correzione su questo pagamento.",
  "payments.detail.actions": "Correggi",
  "payments.detail.neverOptimistic":
    "Nulla è mostrato come fatto prima della risposta del server. Un rimborso senza risposta dal fornitore non viene mai reinviato.",
  "payments.col.kind": "Correzione",
  "payments.col.amount": "Importo",
  "payments.col.status": "Esito",
  "payments.col.by": "Da",
  "payments.col.actions": "Azioni",

  "payments.adjustment.status.pending": "Stato sconosciuto, verifica in corso",
  "payments.adjustment.status.done": "Fatto",
  "payments.adjustment.status.failed": "Rifiutato dal fornitore",
  "payments.adjustment.status.awaiting_manual_transfer": "Bonifico manuale da fare",
  "payments.adjustment.status.awaiting_approval": "In attesa di approvazione",
  "payments.adjustment.status.rejected": "Rifiutato dal proprietario",
  "payments.adjustment.outcomeUnknownHint":
    "Inviato al fornitore senza risposta. Non viene mai reinviato: controlla sulla sua dashboard, poi chiudilo.",
  "payments.adjustment.manualHint":
    "Orange Money non ha il rimborso automatico: invia il denaro a mano, poi chiudilo con il riferimento del trasferimento.",

  "payments.action.refund": "Rimborsa",
  "payments.action.credit": "Accredita",
  "payments.action.waive": "Annulla la commissione",
  "payments.action.markPaid": "Segna come pagato",
  "payments.action.settle": "Chiudi",
  "payments.action.approve": "Approva",
  "payments.action.reject": "Rifiuta",

  "payments.dialog.refund.title": "Rimborsa · {subject}",
  "payments.dialog.refund.body":
    "Il rimborso viene salvato e poi inviato una sola volta al fornitore. Oltre la soglia, attende l'approvazione di un proprietario.",
  "payments.dialog.credit.title": "Accredita · {subject}",
  "payments.dialog.credit.body": "Un saldo detratto dalle prossime commissioni del pro, nella stessa valuta.",
  "payments.dialog.waive.title": "Annulla la commissione · {subject}",
  "payments.dialog.waive.body":
    "La commissione non è più dovuta. Oltre la soglia, l'annullamento attende l'approvazione di un proprietario.",
  "payments.dialog.markPaid.title": "Segna come pagato · {subject}",
  "payments.dialog.markPaid.body":
    "Solo con il riferimento del pagamento reale (l'SMS del pro o l'estratto conto). Un riferimento segna un solo pagamento.",
  "payments.dialog.settle.title": "Chiudi il rimborso · {subject}",
  "payments.dialog.settle.body": "Annota come si è concluso il rimborso, dopo averlo verificato presso il fornitore.",
  "payments.dialog.approve.title": "Approva la richiesta di {subject}",
  "payments.dialog.approve.body": "La correzione richiesta si applica da subito. Nessuno approva la propria richiesta.",
  "payments.dialog.reject.title": "Rifiuta la richiesta di {subject}",
  "payments.dialog.reject.body": "Nulla viene rimborsato né annullato. Il motivo resta con la richiesta.",
  "payments.field.amount": "Importo ({currency})",
  "payments.field.refundHint": "Lascia vuoto per rimborsare tutto: {amount}.",
  "payments.field.orangeMoneyReference": "Riferimento della transazione Orange Money",
  "payments.field.reference": "Riferimento presso il fornitore",
  "payments.field.referenceHint": "Copialo per intero dall'SMS o dall'estratto conto: lettere, cifre e . _ : / -",
  "payments.field.outcome": "Risultato",
  "payments.field.outcome.done": "Il denaro è partito",
  "payments.field.outcome.failed": "Il rimborso non è riuscito",

  "payments.problem.reason": "Indica un motivo di almeno {min} caratteri.",
  "payments.problem.amount": "Inserisci un importo maggiore di zero, con al massimo due decimali.",
  "payments.problem.tooMuch": "È più di quanto resta rimborsabile.",
  "payments.problem.reference":
    "Copia il riferimento per intero: almeno {min} caratteri, solo lettere, cifre e . _ : / -.",

  "payments.outcome.done": "{kind} di {amount}: fatto.",
  "payments.outcome.pending":
    "{kind} di {amount}: stato sconosciuto, verifica in corso. Non verrà reinviato; chiudilo dopo la verifica.",
  "payments.outcome.awaiting_manual_transfer":
    "{kind} di {amount} salvato: invia il denaro a mano, poi chiudilo con il riferimento.",
  "payments.outcome.awaiting_approval": "{kind} di {amount}: oltre ciò che puoi fare da solo, attende un'approvazione.",
  "payments.outcome.failed": "{kind} di {amount} rifiutato dal fornitore ({failure}). Non è cambiato nulla.",
  "payments.outcome.rejected": "{kind} di {amount} rifiutato.",

  "payments.approvals.status.pending": "In attesa",
  "payments.approvals.status.approved": "Approvate",
  "payments.approvals.status.rejected": "Rifiutate",
  "payments.approvals.loading": "Caricamento delle richieste…",
  "payments.approvals.loadFailed": "Impossibile caricare le richieste di approvazione.",
  "payments.approvals.empty": "Nessuna richiesta qui.",
  "payments.approvals.requested": "Richiesto da {name} il {date}",
  "payments.approvals.permission": "Permesso: {permission}",
  "payments.approvals.theirLimit": "Il loro limite: {amount}",
  "payments.approvals.noPermission": "Questa persona non ha questo permesso.",
  "payments.approvals.noLimitInCurrency": "Questa persona non ha limiti in questa valuta.",
  "payments.approvals.openPro": "Apri il pro →",
  "payments.approvals.decided": "Deciso da {name} il {date}",
  "payments.approvals.openPayment": "Apri il pagamento →",
  "payments.approvals.own": "È la tua richiesta: deve deciderla un altro proprietario.",

  "payments.export.month": "Mese da esportare",
  "payments.export.reason": "Motivo (facoltativo)",
  "payments.export.button": "Esporta il CSV",
  "payments.export.running": "Esportazione…",
  "payments.export.hint":
    "I pagamenti del mese (UTC) per la riconciliazione, senza telefono né email. Ogni esportazione viene registrata nel registro di audit.",
  "payments.export.done": "Esportazione scaricata. È registrata nel registro di audit.",

  "payments.error.stale": "Questo pagamento è cambiato mentre lo guardavi. Ricaricalo, controlla e ricomincia.",
  "payments.error.refused":
    "Correzione rifiutata: i tuoi ruoli non includono la funzionalità necessaria. Chiedi l'accesso a un responsabile.",
  "payments.error.approvalRefused":
    "Rifiutato: solo un proprietario con APPROVE_PAYMENT_REQUESTS può decidere, e mai sulla propria richiesta.",
  "payments.error.invalid":
    "Rifiutato: il pagamento non è più nello stato previsto, l'importo supera quanto resta, oppure il riferimento è già usato. Ricarica e controlla.",
  "payments.error.outcomeUnknown":
    "Nessuna risposta dal server: la correzione potrebbe essere stata salvata. Riprova: lo stesso clic non può essere applicato due volte.",

  "payments.refused.notRefundable": "Rifiutato: si può rimborsare solo una commissione pagata. Ricarica il pagamento.",
  "payments.refused.nothingToRefund":
    "Rifiutato: questa commissione è già rimborsata per intero, o il resto è in attesa. Ricarica il pagamento.",
  "payments.refused.refundTooLarge": "Rifiutato: l'importo supera quanto resta da rimborsare su questa commissione.",
  "payments.refused.alreadyAwaitingApproval":
    "Rifiutato: un'esenzione di questa commissione attende già un proprietario. Ricarica il pagamento.",
  "payments.refused.notMarkable":
    "Rifiutato: solo una commissione in attesa o fallita può essere segnata come pagata. Ricarica il pagamento.",
  "payments.refused.referenceInUse":
    "Rifiutato: questo riferimento Orange Money ha già pagato un'altra commissione. Controlla il riferimento.",
  "payments.refused.referenceRequired": "Inserisci il riferimento della transazione.",
  "payments.refused.alreadySettled": "Questo rimborso è stato appena regolato. Ricaricalo.",
  "payments.refused.alreadyDecided": "Questa richiesta è stata appena decisa. Ricarica l'elenco.",
  "payments.refused.ownRequest": "Rifiutato: hai fatto tu questa richiesta, quindi decide un altro proprietario.",
  "payments.refused.approverNotPermitted":
    "Non hai questo permesso per questo importo, quindi non puoi decidere. Decide un'altra persona.",
  "payments.refused.paymentChanged":
    "Rifiutato: il pagamento è cambiato dalla richiesta. Rifiutala invece, con il motivo.",
  "payments.refused.currencyMismatch": "Rifiutato: il credito deve essere nella valuta della commissione.",
  "payments.refused.feeOfAnotherPro": "Rifiutato: questa commissione è stata pagata da un altro professionista.",
  "payments.refused.invalidAmount": "Rifiutato: l'importo deve essere maggiore di zero.",
};
